import { render, staticRenderFns } from "./mode9More.vue?vue&type=template&id=a0238056&scoped=true"
import script from "./mode9More.vue?vue&type=script&lang=js"
export * from "./mode9More.vue?vue&type=script&lang=js"
import style0 from "./mode9More.vue?vue&type=style&index=0&id=a0238056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0238056",
  null
  
)

export default component.exports